"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CopyToClipboard = void 0;
var _components = require("@ori-ui/components");
var _icons = require("@ori-ui/icons");
var _mui = require("@ori-ui/mui");
var _react = require("react");
var _logger = require("../../logger");
var _jsxRuntime = require("react/jsx-runtime");
const logger = _logger.mainLogger.createChild('CopyToClipboard');
const CopyToClipboard = ({
  text
}) => {
  const [copied, setCopied] = (0, _react.useState)(false);
  const handleCopy = async () => {
    if (typeof navigator.clipboard?.writeText === 'function') {
      try {
        await navigator.clipboard.writeText(text);
        setCopied(true);
        setTimeout(() => setCopied(false), 1500);
      } catch (error) {
        logger.error(new Error('Failed to copy to clipboard', {
          cause: error
        }));
      }
    }
  };
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_mui.Tooltip, {
    title: copied ? 'Copied!' : 'Copy to clipboard',
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_components.IconButton, {
      onClick: handleCopy,
      size: "small",
      children: copied ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_icons.Check, {
        fontSize: "small"
      }) : /*#__PURE__*/(0, _jsxRuntime.jsx)(_icons.Copy, {
        fontSize: "small"
      })
    })
  });
};
exports.CopyToClipboard = CopyToClipboard;
